<template>
  <div>
    <h1>
      <Icon
        name="Privacy Primary"
        class="shrink-0 text-primary w-[1em] h-[1em] align-middle inline-block text-start"
      />
      {{ $t("pages.account.password-reset.title") }}
    </h1>

    <section class="bg-[#F0FBFB] p-4 mt-10 py-14">
      <div class="max-w-5xl mx-auto grid md:grid-cols-2 gap-6">
        <div class="md:shadow-md md:p-7 bg-white rounded-sm p-7">
          <CommonAlert
            v-if="actionState"
            :type="actionState.status"
            :content="actionState.message"
            class="mb-6"
          />
          <p class="max-w-xs mt-6">
            {{ $t("pages.account.password-reset.texts.description") }}
          </p>

          <VForm
            :validation-schema="Schema"
            :initial-values="Schema.getDefault()"
            v-slot="form"
            as="div"
            class="w-full mt-6"
          >
            <form @submit="form.handleSubmit($event, mutate)" class="mx-auto">
              <div class="w-full -mt-2 md:mt-0">
                <div class="flex flex-col md:gap-4 md:pt-4">
                  <BaseVTextInput
                    type="email"
                    name="email"
                    :label="`${$t('common.fields.email')}`"
                  />
                </div>

                <BaseButton
                  type="submit"
                  :text="$t('pages.account.password-reset.buttons.email_signin_link')"
                  class="w-fit h-10 text-[1rem] mt-4"
                  :loading="pending"
                  :disabled="!canExecute"
                />
              </div>
            </form>
          </VForm>
        </div>

        <CommonLookingForTestResultCard />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import * as yup from "yup";

const { t } = useI18n();

interface PasswordResetResponse {
  status: "success" | "error";
  message: string;
}
const actionState = ref<PasswordResetResponse>();

const Schema = yup.object({
  email: yup.string().email().required().default(""),
});
type Schema = yup.InferType<typeof Schema>;

const { pending, mutate, canExecute } = useMutation({
  executionInterval: 5,
  executionIntervalUnit: "seconds",
  mutationFn: (credentials: Schema) =>
    useAxios().postForm<{ status: boolean }>(
      `/password/reset-link`,
      credentials
    ),
  onError(err) {
    console.error(err);
    actionState.value = {
      status: "error",
      message: err.message,
    };
  },
  onSuccess({ data }) {
    actionState.value = {
      status: data.status ? "success" : "error",
      message: t("pages.account.password-reset.texts.success"),
    };
  },
});
</script>
